import React, { Component } from 'react';
import {
  useNavigate, useLocation, NavigateFunction, Location,
} from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import { Close } from '@mui/icons-material';
import { SuccessSnackBar, FailedSnackBar, IconButtonWhite } from './styles';
import { verifyTwitterToken } from '../../../api/vault/verifyToken';
import { Routes } from '../../../constants';

interface IProps {
  navigate: NavigateFunction;
  location: Location;
}

class TwitterTokenVerificationInner extends Component<IProps> {
  state = {
    isVerificationComplete: false,
    isVerificationSuccessful: false,
  };

  componentDidMount() {
    this.verifyTokenAndRedirect();
  }

  getQuery = () => {
    const {
      location,
    } = this.props;

    return new URLSearchParams(location.search);
  };

  verifyTokenAndRedirect = async () => {
    const query = this.getQuery();

    try {
      await verifyTwitterToken({
        oauthToken: query.get('oauth_token'),
        oauthVerifier: query.get('oauth_verifier'),
      });
      this.setState({
        isVerificationSuccessful: true,
      });
    } finally {
      this.setState({
        isVerificationComplete: true,
      });
    }
  };

  getMessage = () => {
    const {
      isVerificationSuccessful,
    } = this.state;

    return isVerificationSuccessful
      ? 'X token verification successful'
      : 'Error during X token verification';
  };

  renderActions = () => {
    const {
      navigate,
    } = this.props;

    return [
      <IconButtonWhite
        key="close"
        onClick={() => navigate(Routes.HOME, { replace: true })}
      >
        <Close />
      </IconButtonWhite>,
    ];
  };

  render() {
    const {
      isVerificationComplete,
      isVerificationSuccessful,
    } = this.state;

    return (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={isVerificationComplete}
      >
        {isVerificationSuccessful
          ? <SuccessSnackBar message={this.getMessage()} action={this.renderActions()} />
          : <FailedSnackBar message={this.getMessage()} action={this.renderActions()} />}
      </Snackbar>
    );
  }
}

// Wrapper component to provide router hooks
const TwitterTokenVerification: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return <TwitterTokenVerificationInner navigate={navigate} location={location} />;
};

export default TwitterTokenVerification;
